<template>
    <div id="authentication" v-loading="loading">
        <div class="container">

            <p class="text-center d-block mt-5">お支払い方法選択</p>
                <p>
                    定期購読のご登録がされていません。<br>
                    下記ボタンから、お支払い方法を選択してください。<br>
                </p>

                <el-button @click="checkout">クレジットカード</el-button>
                <el-button @click="paypal">Paypal</el-button>

        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import $userRepository from '../../backend/userRepository'
import {loadStripe} from '@stripe/stripe-js';
import { Message } from 'element-ui'

export default {
    mounted() {
        let stripeScript = document.createElement('script');
        stripeScript.setAttribute('src', 'https://js.stripe.com/v3/')
        document.head.appendChild(stripeScript)
    },
    data() {
        return {
            user_id: '',
            loading: false
        }
    },
    computed: {
        ...mapState({
            user: state => (state.auth.user)
        })
    },
    methods: {
        async checkout() {
            this.loading = true;
            var stripe = await loadStripe(process.env.VUE_APP_STRIPE_API_KEY);
            $userRepository.pay(this.user.id)
            .then(response => {
                if(response.data.is_reach) {
                    Message({
                        message: '既に購読登録済みです',
                        type: 'warning',
                        duration: 0,
                        showClose: true
                    });
                    this.$router.push({ path: '/'});
                } else {
                    stripe.redirectToCheckout({ sessionId: response.data.session_id });
                }
            })
            .catch(error => {
                console.error(error.response);
                Message({
                    message: 'エラーが発生しました。管理者にお問い合わせください。',
                    type: 'warning',
                    duration: 0,
                    showClose: true
                });
                this.$router.push({ path: '/'});
            });
        },
        paypal() {
            this.$router.push({ path: '/pay/paypal'});
        }
    }
}

// ブラウザバックによる多重決済防止処理
if(document.referrer.indexOf('stripe.com')){
    window.onpopstate = function() {
        location.reload(true);
    };
}
</script>

<style scoped>
#authentication {
  position: fixed;
  background: white;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100000;
  text-align: center;
  overflow-y: auto;
}
</style>